/*
 *
 * (object) proxy
 *
 */
type LazyGetter = (this: object) => unknown

export default function proxy (schema: Record<string, LazyGetter>) {
  const descriptor: PropertyDescriptorMap = {}

  Object.keys(schema).map(k => {
    const cache = '_$' + k
    descriptor[k] = {
      get () {
        if (Object.prototype.hasOwnProperty.call(this, cache)) return (this as Record<string, unknown>)[cache]
        ;(this as Record<string, unknown>)[cache] = schema[k].apply(this)
        return (this as Record<string, unknown>)[cache]
      },
    }
  })

  return function (root: unknown) {
    return function (o: object) {
      Object.defineProperties(o, descriptor)
      ;(o as { $root?: unknown }).$root = root
      return o
    }
  }
}
